<template>
  <i-ep-setting />
</template>
